const DEFAULT_API_BASE_URL = "http://127.0.0.1:1234";

export const API_BASE_URL =
  process.env.REACT_APP_API_URL || DEFAULT_API_BASE_URL;

export const buildApiUrl = (path = "") => {
  const normalizedPath = String(path).startsWith("/") ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
};

export const authHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
});

export const authFetch = (url, options = {}) => {
  const isFormData = options.body instanceof FormData;
  const method = (options.method || "GET").toUpperCase();

  // Block writes when offline
  if (!navigator.onLine && method !== "GET") {
    return Promise.reject(
      new Error("You are offline. Please reconnect to perform this action."),
    );
  }

  return fetch(url, {
    ...options,
    headers: {
      ...(isFormData ? {} : { "Content-Type": "application/json" }),
      Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
      ...(options.headers || {}),
    },
  });
};
